export enum FormFieldValueTypeEnum {
    String = 1,
    Radio = 2,
    Checkbox = 3,
    Dropdown = 4,
    Textarea = 5,
    Image = 6,
    ImageUpload = 7,
    Date = 8,
    PhoneNumber = 9,
    Email = 10,
    Text = 11,
    Number = 12,
    FileUpload = 13,
    Signature = 14,
    Lookup = 15,
    Html = 16,
    List = 17,
    Title = 18,
    SubSection = 19,
    FileDownload = 20,
    RadioButton = 21,
    Slider = 22,
    Table = 23,
    InfoAlert = 24,
    SuccessAlert = 25,
    DangerAlert = 26,
    WarningAlert = 27,
    VideoEmbed = 28,
    Time = 29,
    DataTypeAutoComplete = 30,
    DatePicker = 31,
    Link = 32,
    DataTypeMultipleAutoComplete = 33,
    OptionSelection = Radio | Checkbox | Dropdown | Lookup | RadioButton
}


export function isFormFieldValueTypeEnumOptions(formFieldValueTypeId: FormFieldValueTypeEnum | "") {
    return formFieldValueTypeId == FormFieldValueTypeEnum.Radio ||
        formFieldValueTypeId == FormFieldValueTypeEnum.Dropdown ||
        formFieldValueTypeId == FormFieldValueTypeEnum.Checkbox ||
        formFieldValueTypeId == FormFieldValueTypeEnum.Lookup ||
        formFieldValueTypeId == FormFieldValueTypeEnum.RadioButton
}